export default {
  "switch": "_switch_1gc5uf",
  "default": "_default_1gc5uf",
  "accent": "_accent_1gc5uf",
  "switch-grid": "_switch-grid_1gc5uf",
  "input": "_input_1gc5uf",
  "label": "_label_1gc5uf"
};